import { Button } from "components/Button"
import { Header } from "components/Header"
import { InputFormField } from "components/InputFormField"
import { Loading } from "components/Loading"
import { PlaceHolderNotExists } from "components/PlaceholderNotExists"
import { TableModifiedCards } from "components/TableModified/TableModifiedCards"
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters"
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination"
import { TableModifiedTable } from "components/TableModified/TableModifiedTable"
import { Container, TableSearchUsers } from "./styles"
import { useCustomersTable } from "./useCustomersTable"

const tableHead = ["Nome", "Id. verificada", "CPF", "Último login", "E-mail", ""];

export const CustomersTable:React.FC = () => {
  const {
    loading,
    error,
    properties,
    customerRows,
    customersCount,
    searchText,
    tableFilters,
    searchTextFormRef,
    pageNumber,
    customersPerPage,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handleClearFilters,
    handlePageSelected,
    handleRowsPerPageChange,
  } = useCustomersTable();
  return (
    <Container>
      <Header>
        <TableSearchUsers
          className="table-search-user"
          onSubmit={handleSearchTextFormSubmit}
          ref={searchTextFormRef}
        >
          <InputFormField 
            label="Buscar Usuários" 
            autoFocus={true} 
            name="searchText" 
            marginBotton={"0"} 
            backGround={"white"}
            defaultValue={searchText}
            block={true} 
          />
          <Button 
            label="Buscar" 
            typeBtn="blue"
            type="submit"
            block={false} 
          />
        </TableSearchUsers>
      </Header>
      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />
      {
        loading
        ? <Loading/>
        : error
          ? <PlaceHolderNotExists title="Erro ao se comunicar com o servidor"/>
          : <>
              <TableModifiedCards
                properties={properties}
              />
              <TableModifiedTable
                headerColumns={tableHead}
                rows={customerRows}
                onClearFilters={handleClearFilters}
              />
            </>
      }
      {
        customersCount > 0
        ? <TableModifiedPagination
            totalItemsCount={customersCount}
            pageNumber={pageNumber}
            rowsPerPage={customersPerPage}
            onPageSelected={handlePageSelected}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        : null
      }
    </Container>
  )
}